import api from './api'

// Web Push (PWA) — suscribe/desuscribe este dispositivo a las notificaciones push.

function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4)
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/')
  const raw = atob(base64)
  const arr = new Uint8Array(raw.length)
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i)
  return arr
}

export const pushService = {
  isSupported(): boolean {
    return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window
  },

  permission(): NotificationPermission {
    return typeof Notification !== 'undefined' ? Notification.permission : 'denied'
  },

  async isSubscribed(): Promise<boolean> {
    if (!this.isSupported()) return false
    try {
      const reg = await navigator.serviceWorker.ready
      const sub = await reg.pushManager.getSubscription()
      return !!sub
    } catch { return false }
  },

  async enable(): Promise<void> {
    if (!this.isSupported()) throw new Error('unsupported')

    const perm = await Notification.requestPermission()
    if (perm !== 'granted') throw new Error('denied')

    const { data } = await api.get('/push/public-key')
    if (!data?.key) throw new Error('no-vapid')

    const reg = await navigator.serviceWorker.ready
    let sub = await reg.pushManager.getSubscription()
    if (!sub) {
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(data.key) as BufferSource,
      })
    }
    await api.post('/push/subscribe', { subscription: sub.toJSON() })
  },

  async disable(): Promise<void> {
    if (!this.isSupported()) return
    const reg = await navigator.serviceWorker.ready
    const sub = await reg.pushManager.getSubscription()
    if (sub) {
      await api.post('/push/unsubscribe', { endpoint: sub.endpoint }).catch(() => {})
      await sub.unsubscribe().catch(() => {})
    }
  },
}
